<template>
  <v-form form="form">
    <v-select
      id="axis-select"
      v-model="filter.instituicaoId"
      item-text="nome"
      item-value="instituicaoid"
      :items="instituicao"
      :label="name || 'Instituição'"
      :placeholder="name || 'Instituição'"
      :rules="rules"
      clearable
    >
      <!-- <div
        style="display: flex; padding: 0 16px; cursor: pointer"
        slot="prepend-item"
        ripple
        @click="toggle"
      >
        <div style="margin-right: 32px">
          <v-icon
            :color="filter.instituicao.length > 0 ? 'indigo darken-4' : ''"
            >{{ icon }}</v-icon
          >
        </div>
        <div>Todos</div>
      </div> -->
      <!-- <v-divider slot="prepend-item" class="mt-2" /> -->

      <!-- <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay"
          >{{ item.nome
          }}{{
            index === 0 && filter.instituicao && filter.instituicao.length > 1
              ? ","
              : ""
          }}
          &nbsp;</span
        >
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ filter.instituicao.length - maxDisplay }} instituições)</span
        >
      </template> -->

      <template slot="no-data"> Nenhuma Instituição retornada </template>
    </v-select>
  </v-form>
</template>

<script>
import { instituicaoAPI } from "../API/instituicaoAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ComboboxInstituicao",
  props: ["filter", "name", "rules"],
  mounted() {
    this.loadAxis();
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  methods: {
    loadAxis() {
      instituicaoAPI
        .list({ municipios: [this.municipioId] })
        .then((resp) => {
          if (
            this.isFullAdmin ||
            (this.config.verTodasInstituicao &&
              this.groupsConfig.verTodasInstituicao)
          ) {
            this.instituicao = resp.data;
          } else {
            const permissaoUser = this.userTeste.permissoes.map(
              (item) => item.municipioId
            );

            this.instituicao = resp.data.filter((item) => {
              return item.municipioIds.filter((val) =>
                permissaoUser.includes(val)
              );
            });
          }
        })
        .catch();
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.instituicao = [];
        } else {
          this.filter.instituicao = this.instituicao.slice();
        }
      });
    },
  },
  computed: {
    likesAll() {
      return this.filter.instituicao.length === this.instituicao.length;
    },
    likesSome() {
      return this.filter.instituicao.length > 0 && !this.instituicao;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 1,
      municipioId: this.$route.params.id,
      instituicao: [],
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
};
</script>
